import { render, staticRenderFns } from "./FooterV2.vue?vue&type=template&id=c5f86942&scoped=true&"
import script from "./FooterV2.vue?vue&type=script&lang=js&"
export * from "./FooterV2.vue?vue&type=script&lang=js&"
import style0 from "./FooterV2.vue?vue&type=style&index=0&id=c5f86942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f86942",
  null
  
)

export default component.exports